import { render, staticRenderFns } from "./MoveCategoryProduct.vue?vue&type=template&id=1654b480&scoped=true"
import script from "./MoveCategoryProduct.vue?vue&type=script&lang=js"
export * from "./MoveCategoryProduct.vue?vue&type=script&lang=js"
import style0 from "./MoveCategoryProduct.vue?vue&type=style&index=0&id=1654b480&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1654b480",
  null
  
)

export default component.exports